import { render, staticRenderFns } from "./modelDetail.vue?vue&type=template&id=e7407216&scoped=true"
import script from "./modelDetail.vue?vue&type=script&lang=js"
export * from "./modelDetail.vue?vue&type=script&lang=js"
import style0 from "./modelDetail.vue?vue&type=style&index=0&id=e7407216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7407216",
  null
  
)

export default component.exports